import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { DxFileUploaderComponent } from 'devextreme-angular';
import { ClientService } from 'src/app/services/client.service';
import { SessionContextService } from 'src/app/services/session-context.service';
import { Branch } from '../../model/Branch.model';
import { Client } from '../../model/client.model';
import { alert } from "devextreme/ui/dialog"
import { ClientPhotoComponent } from '../client-photo/client-photo.component';
import { WebcamUtil } from 'ngx-webcam';

@Component({
  selector: 'app-client-photo-upload',
  templateUrl: './client-photo-upload.component.html',
  styleUrls: ['./client-photo-upload.component.css']
})
export class ClientPhotoUploadComponent implements OnInit {

  @ViewChild(DxFileUploaderComponent) fileUploadControl: DxFileUploaderComponent;
  @ViewChild(ClientPhotoComponent) webCamControl: ClientPhotoComponent;

  isDropZoneActive = false;
  imageSource = '';
  deleteImage:boolean= false; 
  isWebCamAvailable:boolean=false;

  clientId:number= null;
  @Input() public set selectedClient(clientId: number) {
    this.SetClient(clientId);
  }
  @Output() photoUploaded = new EventEmitter<boolean>();

  constructor(private clientService: ClientService, private session: SessionContextService, private changeDetectorRef: ChangeDetectorRef) {
    this.onDropZoneEnter = this.onDropZoneEnter.bind(this);
    this.onDropZoneLeave = this.onDropZoneLeave.bind(this);
    this.onValueChanged =this.onValueChanged.bind(this);      
  }

  ngOnInit(): void {  
  }

  public SetClient(clientId: number) {
    
    WebcamUtil.getAvailableVideoInputs()
    .then((mediaDevices: MediaDeviceInfo[]) => {            
      this.isWebCamAvailable = (mediaDevices && mediaDevices.length >= 1)      
      this.changeDetectorRef.detectChanges();
    });
      
    this.clientId = clientId;
    this.ResetImageSource();     
  }

  ResetImageSource() {
    this.imageSource="";
    var b: Branch = this.session.GetSelectedBranch();
    var cacheBuster = Math.round(new Date().getTime() / 1000);       
    this.imageSource = `/api/Clients/ClientPhoto?TEntity=${b.TenantHash}&C=${this.clientId}&cb=${cacheBuster}`;
  }

  onDropZoneEnter(e) {
    if (e.dropZoneElement.id === 'dropzone-external') { this.isDropZoneActive = true; }
  }

  onDropZoneLeave(e) {
    if (e.dropZoneElement.id === 'dropzone-external') { this.isDropZoneActive = false; }
  }

  onDropZoneValueChanged(e) {
    this.fileUploadControl.value = e.value;
  }
  
  onValueChanged(e) {  
    if (e.value.length != 1)
      return;
    
    const file = e.value[0];

    // Check file size and extension 
    var error = "";
    if (file.size < 1 || file.size > (4 * 1024 * 1024)) {
      // File too large
      error = "The selected file is too large to be uploaded.";
    }
    if (file.type != "image/png" && file.type != "image/jpeg") {
      error = "The selected file is not an valid PNG or JPG image file.";
    }

    if (error.length > 0) {
      // show Error as popup
      alert(error, "Error").then(_ => {
        this.fileUploadControl.resetOptions("value");        
        this.isDropZoneActive=false;
      });
      return;
    }
    const fileReader = new FileReader();
    fileReader.onerror = (e) => {
      alert("Failed to read file. Check that the file exists and that you have permissions to read the file.", "Error").then(_ => {
        fileReader.abort();
        this.fileUploadControl.resetOptions("value");      
        this.isDropZoneActive=false;
      });
    };

    fileReader.onload = () => {
      this.isDropZoneActive = false;
      this.imageSource = fileReader.result as string;
      this.deleteImage=false;
      this.changeDetectorRef.detectChanges();
      this.photoUploaded.emit(true);
    };
    this.imageSource="";
    fileReader.readAsDataURL(file);    
  }

  btnDeleteImage(e) {
    this.imageSource="";
    this.deleteImage=true;
    this.isDropZoneActive = false;
    this.photoUploaded.emit(false);
  }

  btnUseWebCam(e) {    
    // Show webcam dlg.
    this.webCamControl.show();
  }
  
  webCamImageCaptured(e)
  {
    // if we have new image then save that.    
    if (e && e.length>100)
    { 
      this.imageSource=e;
      this.deleteImage=false;
    }
  }

}
